import { APIResponse, APIResponseDtoImpl } from '../apiresponse';
import { CategoryDto } from '../../dto/categories/categorydto';


export interface CategoriesResponse extends APIResponse 
{
   getCategoriesList() : CategoryDto[];
}

export class CategoriesResponseDtoImpl extends APIResponseDtoImpl implements CategoriesResponse 
{
    private categoriesList: CategoryDto[];

    getCategoriesList(): CategoryDto[]
    {
        return this.categoriesList;
    }
    setCategoriesList(categoriesList: CategoryDto[])
    {
        this.categoriesList = categoriesList;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/categories/categoriesresponse.tsx